module.exports = __webpack_public_path__ + "static/media/Group 84.b72fabd6.png";